// extracted by mini-css-extract-plugin
module.exports = {"Button":"ModalHeader_Button__1_wHN"};